import { NgModule } from '@angular/core';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AppMenuitemComponent } from './sidebar/app-menuitem.component';
import { AppMenuComponent } from './sidebar/app-menu.component';
import { LayoutComponent } from './sidebar/layout.component';
import { TopbarComponent } from './topbar/topbar.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { DialogService } from 'primeng/dynamicdialog';

import { SharedModule } from '../../shared/modules/shared.module';

@NgModule({
	declarations: [
		SidebarComponent,
		AppMenuitemComponent,
		AppMenuComponent,
		LayoutComponent,
		TopbarComponent,
		BreadcrumbComponent
	],
	imports: [SharedModule],
	exports: [LayoutComponent],
	providers: [DialogService]
})
export class AppLayoutModule {}
